const React = require("react")
const { AuthProvider } = require("./src/providers/firebase/auth")

exports.wrapPageElement = ({ element }) => {
  return <AuthProvider>{element}</AuthProvider>
}
